<script setup lang="ts">
  import type { PropType } from 'vue';
  import ContactForm from '@/components/contact/ContactForm.vue';
  import type { ContactFormData } from '@/models/contact';
  import { useGoogleRecaptcha } from '@/composables/useGoogleRecaptcha';
  import { useRoute } from 'vue-router';

  defineProps({
    localePath: {
      type: Function as PropType<(to: any) => string>,
      required: true
    }
  });

  const { executeRecaptcha } = useGoogleRecaptcha();

  const propForm = useTemplateRef('propForm');

  const route = useRoute();

  const onSubmit = async (data: ContactFormData) => {
    if (!propForm.value) return;

    const result = await propForm.value.validate();
    if (!result.valid) return;

    try {
      const { recaptchaData } = await executeRecaptcha('contact');

      await $api<ContactFormData>('/contact-form/save', {
        method: 'POST',
        body: {
          name: data.name,
          email: data.email,
          companyName: data.companyName,
          phone: data.phone,
          vatNumber: data.vatNumber || null,
          zipCode: data.zipCode || null,
          city: data.city || null,
          address: data.address || null,
          comment: data.comment || null,
          context: route.query.slug ?? 'Egyedi',
          consentPrivacyPolicy: data.consentPrivacyPolicy,
          consentMarketing: data.consentMarketing || null,
          package: 'Egyedi',
          packageConfig: JSON.stringify(propForm.value.values),
          ...recaptchaData
        }
      });
      data.resetForm?.call(null);
      (data as any).isSuccess.value = true;
    } catch (error) {
      console.error('Failed to submit contact form');
      console.error(error);
      (data as any).isError.value = true;
    }
  };
</script>

<template>
  <section class="custom-package-section">
    <div class="container">
      <div class="custom-package-section__wrapper">
        <div class="custom-package-section__left">
          <h2 class="custom-package-section__title">{{ $t('customPackage.title') }}</h2>
          <p class="custom-package-section__subtitle">
            {{ $t('customPackage.description') }}
          </p>
          <UseCasePackagesCustomPackageForm ref="propForm" />
        </div>
        <div class="custom-package-section__right">
          <ContactForm
            :locale-path="localePath"
            submit-label="customPackage.form.submit"
            @on-submit="onSubmit" />
        </div>
      </div>
    </div>
  </section>
</template>
